import { render, staticRenderFns } from "./RegisterLogs.vue?vue&type=template&id=6a7bf32e"
import script from "./RegisterLogs.vue?vue&type=script&lang=js"
export * from "./RegisterLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports